import type { ResidentApplicationData } from '../types'

/**
 * Merges property fields from nested `property` and application root (API shape varies).
 * Mirrors Angular `applicationAllData?.property` usage on resident detail.
 */
export function mergeApplicationProperty(application: ResidentApplicationData): ResidentApplicationData {
  const raw = application as Record<string, unknown>
  const nested = (application.property || {}) as Record<string, unknown>

  const pickString = (...keys: string[]): string | undefined => {
    for (const key of keys) {
      const fromNested = nested[key]
      if (fromNested !== null && fromNested !== undefined && String(fromNested).trim() !== '') {
        return String(fromNested).trim()
      }
      const fromRoot = raw[key]
      if (fromRoot !== null && fromRoot !== undefined && String(fromRoot).trim() !== '') {
        return String(fromRoot).trim()
      }
    }
    return undefined
  }

  const pickListed = (key: string): number | string | undefined => {
    const nestedVal = nested[key]
    if (nestedVal !== null && nestedVal !== undefined && nestedVal !== '') return nestedVal as number | string
    const rootVal = raw[key]
    if (rootVal !== null && rootVal !== undefined && rootVal !== '') return rootVal as number | string
    return undefined
  }

  const propertyIdRaw =
    nested.property_id ?? raw.property_id ?? raw.fk_property_id
  const propertyId =
    propertyIdRaw !== null && propertyIdRaw !== undefined && String(propertyIdRaw).trim() !== ''
      ? propertyIdRaw
      : undefined

  return {
    ...application,
    property: {
      ...nested,
      ...(propertyId !== undefined ? { property_id: propertyId as string | number } : {}),
      company_name: pickString('company_name'),
      company_listed: pickListed('company_listed'),
      property_name: pickString('property_name'),
      property_phone: pickString('property_phone', 'property_phone_number'),
      property_listed: pickListed('property_listed'),
      customer_success_mgr: pickString('customer_success_mgr', 'property_support_team'),
    },
  }
}
